import React, { Component } from "react";
import { Grid, Header, Segment, Transition, Button, Icon, Modal, Image, Message } from "semantic-ui-react";
import { connect } from "react-redux";
import { Config } from "../../../data/config";
import axios from "axios";
import { Loader } from '../../Loader/Loader';
import menuBtnClose from "../../../semantic/dist/themes/fibrestream/assets/images/menu-close.svg";
import { googleTracking } from '../../../util';

const NotifyModal = props => {
  const { open, closeNotifyModal, connecting_instructions } = props;
  return (
    <Modal
      open={open}
      onClose={closeNotifyModal}
      size='small'
      className=" pos-relative mt-0 connecting-instruction modal__message"
      closeOnDimmerClick={false}
    >
      <Modal.Content scrolling className="ui centered grid mx-0 my-0 px-0 py-0">
        <Segment className="all-set-segment">
          {
            (() => {
              if (!connecting_instructions) {
                return <Loader />
              } else if (connecting_instructions && connecting_instructions.error) {
                return <Message error>
                  <Header as='h5' textAlign='center'>
                    We were unable to retrieve the connecting instructions specific to your installation at this time. You will receive your connecting instructions by email shortly.
                          </Header>
                </Message>;
              } else {
                return <div className="avail__desc py-0 text-black" dangerouslySetInnerHTML={{ __html: connecting_instructions }} ></div>;
              }
            })()
          }
        </Segment>
      </Modal.Content>
      <Button className="deny close" secondary onClick={closeNotifyModal}>
        <span className="times text-prime">
          <Image src={menuBtnClose} verticalAlign="middle" />
        </span>
      </Button>
    </Modal>
  );
};


class Step6 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      notifyModal: false,
      connectionInstructions: null,
    };
    this.secondsElapsed = 5;
    this.isAajaxCompleted = true;
    this.transitionNext = this.transitionNext.bind(this);
    this.closeNotifyModal = this.closeNotifyModal.bind(this);
    this.openNotifyModal = this.openNotifyModal.bind(this);
    this.getConnectionInstructions = this.getConnectionInstructions.bind(this);
    this.startConnectionInstructionInterval = this.startConnectionInstructionInterval.bind(this);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
    googleTracking({ 'event': 'virtualPageview', 'pageview': '/prewired/step7/confirmation' });
  }

  transitionNext() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(10, "fade left")
    }, 400);
  }

  openNotifyModal(e) {
    e.preventDefault();

    this.setState({
      notifyModal: true
    });

    this.startConnectionInstructionInterval();
  }

  closeNotifyModal() {

    this.setState({
      notifyModal: false
    });
  }

  startConnectionInstructionInterval() {
    this.getConnectionInstructions();

    let elapsedInterval = setInterval(() => {
      if (this.secondsElapsed >= 30 || this.state.connectionInstructions) {
        clearInterval(elapsedInterval);

        if (!this.state.connectionInstructions) {
          this.setState({
            connectionInstructions: { error: true }
          });
        }
        return;
      }

      this.secondsElapsed += 5;
      this.getConnectionInstructions();

    }, 5000);

    return this.secondsElapsed;
  }

  getConnectionInstructions() {
    const { jobId } = this.props;
    let connectionInstructions = null;

    if (!this.isAajaxCompleted) {
      return;
    }

    this.isAajaxCompleted = false;

    axios
      .get(`${Config.frontApiUrl}/queue/datastore/${jobId}`)
      .then(response => {
        connectionInstructions = response.data.pub_data.connecting_instructions || null;

        if (connectionInstructions) {
          this.setState({
            connectionInstructions: response.data.pub_data.connecting_instructions
          });
        }
      })
      .catch(errors => {
      })
      .finally(() => {
        this.isAajaxCompleted = true;
      });
  }

  render() {
    const { visible, animation, notifyModal, connectionInstructions } = this.state;
    const { activationDateUser, isWifiRouterAdded } = this.props;
    return (
      <div>
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              Confirmation
            </Header>
            <Grid className="instant-activation width__xs confirmation">
              <Grid.Row className="py-0">
                <Grid.Column className="px-0">
                  <Segment inverted textAlign="center">
                    <div className="circle-tick" />
                    <Header as="h3" className="title" textAlign="center">
                      ALL SET!
                    </Header>
                    <Segment
                      className="sub__instant-activation ui inverted mx-4"
                      textAlign="center"
                    >
                      {activationDateUser &&
                        <p className="text-white f-size--14 mb-0">
                        Your service will be activated on
                        <span className="itc-mdbold"> {activationDateUser}</span>
                        </p>
                      }
                      {isWifiRouterAdded &&
                        <p className="px-3 mt-4 alert__all-set"><Icon color="red" name="exclamation triangle"></Icon>
                          <span className="f-size--14">A secure payment link for your router has been sent to you by email. Once payment is received your router will be shipped. </span>
                        </p>
                      }
                    </Segment>
                    <Button
                      secondary
                      className="btn--full text-white"
                      size="medium"
                      onClick={this.transitionNext}
                    >
                      CLOSE
                    </Button>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className="px-4 py-0 learn-more__text">
                <Grid.Column textAlign="center">
                  <p className="itc-std-md f-size--14">
                    Connecting instructions have been sent to you by email. You
                    can also <a className="text-prime cursor-pointer" onClick={this.openNotifyModal}>view them here.</a>
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <NotifyModal open={notifyModal} closeNotifyModal={this.closeNotifyModal} connecting_instructions={connectionInstructions} />
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    activationDateUser: state.form.activationDateUser,
    isWifiRouterAdded: state.form.wifiRouter > 0,
    jobId: state.form.job_id
  };
};

export default connect(mapStateToProps)(Step6);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/Step6.js